import React, { useContext, useMemo } from 'react';
import { useParams } from 'umi';
import AuthPathReport from './AuthPathReport';
import { MenuListContext } from '@/pages/intelligence/layouts/MenuListContext';
import usePageLog from '@intelligence/v3/_hooks/usePageLog';
import { dbiPageLogMes } from '@intelligence/utils/buriedPointCfg';
import type { IDBIMenuVO } from '@intelligence/types/menu';

function findMenu(list: IDBIMenuVO[], title: string): IDBIMenuVO | null {
  for (const item of list) {
    if (item.title === title) return item;
    const found = findMenu(item.subMenus || [], title);
    if (found) return found;
  }
  return null;
}

export default () => {
  const { reportId } = useParams() as { reportId: string };
  const menuList = useContext(MenuListContext);
  const decodedReportId = useMemo(() => {
    try {
      return decodeURIComponent(reportId || '');
    } catch (e) {
      return reportId || '';
    }
  }, [reportId]);
  const currentMenu = useMemo(
    () => findMenu(menuList, decodedReportId),
    [menuList, decodedReportId],
  );

  // 页面打点：所有 authPath 报表共用一个 pageId，通过 uid 区分具体报表
  usePageLog('intelligenceAuthPathReport', {
    uidType: 'reportId',
    uid: decodedReportId,
  });

  return (
    <AuthPathReport
      pageId={dbiPageLogMes?.intelligenceAuthPathReport?.pageId}
      reportId={reportId}
      currentMenu={currentMenu}
      resId="intelligence"
      reportTypeId="intelligence_pc_v2"
      getAuthPath={(menu) => (menu as any).params?.auth_path || ''}
      getMenuId={(menu) => String((menu as any).id || '')}
      getPageType={() => 'auth_path'}
    />
  );
};
